import { Query } from 'graphql/generated/graphqlTypes';
import { generateMockAccessGrant } from 'mocks/graphqlMocks/accessGrant';
import {
  mockDoorHandle1,
  mockDoorReader1,
  mockLocationTestGroup1,
  mockLocationTestGroup2
} from 'mocks/graphqlMocks/doorFixtures';
import {
  mockVisitorInstaller,
  mockVisitorsInstallersAndCleaners,
  mockVisitorsWithGroups
} from 'mocks/graphqlMocks/visitorFixtures';
import { generateMockVisitorGroup } from 'mocks/graphqlMocks/visitorGroup';
import { mockVisitorGroupsInstallersAndCleaners } from 'mocks/graphqlMocks/visitorGroupFixtures';

export function mockedGetVisitorDetailsVisitorGroupsData(
  getVisitorGroupsForTenant: Query['getVisitorGroupsForTenant']
): Pick<Query, 'getVisitorGroupsForTenant'> {
  return {
    getVisitorGroupsForTenant
  };
}

const allVisitors = [...mockVisitorsWithGroups, ...mockVisitorsInstallersAndCleaners];

// Reflects the visitor -> group membership declared in visitorFixtures.ts back onto each group, so the
// tenant-wide groups query (used by the Access overview tab) agrees with the visitor's own group list.
const visitorGroupsWithMembers = mockVisitorGroupsInstallersAndCleaners.map((group) => ({
  ...group,
  members: allVisitors.filter((visitor) =>
    visitor.visitorGroupMembership.some((membership) => membership.visitorGroup.id === group.id)
  )
}));

export const mockedGetVisitorDetailsVisitorGroupsDataForQuery = mockedGetVisitorDetailsVisitorGroupsData([
  ...visitorGroupsWithMembers,
  generateMockVisitorGroup({
    id: 'mockedVisitorGroupId1',
    name: 'Mock Visitor Group 1',
    type: 'VISITOR',
    members: [mockVisitorInstaller],
    accessGrants: [
      generateMockAccessGrant({
        id: 'mockedAccessGrantIdVisitorGroup1',
        locations: [mockLocationTestGroup1, mockLocationTestGroup2],
        doors: [mockDoorReader1, mockDoorHandle1]
      })
    ]
  }),
  generateMockVisitorGroup({
    id: 'mockedVisitorGroupId2',
    name: 'Mock Visitor Group 2',
    type: 'ADMINISTRATORS'
  })
]);
